var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0026 0C8.95562 0 0 8.95562 0 20.0026C0 31.0444 8.95562 40 20.0026 40C31.0444 40 40 31.0444 40 20.0026C40 8.95562 31.0444 0 20.0026 0ZM30.2594 27.3146C30.2594 28.579 29.1321 29.4324 27.8678 29.4324H13.1437C11.8741 29.4324 10.7678 28.579 10.7678 27.3146V12.58C10.7678 11.3157 11.8741 10.4675 13.1437 10.4675H27.8678C29.1321 10.4675 30.2594 11.3157 30.2594 12.58V27.3146Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.869 20.2621C16.869 18.25 18.4983 16.6207 20.5103 16.6207C22.5276 16.6207 24.1621 18.25 24.1621 20.2621C24.1621 22.269 22.5276 23.8983 20.5103 23.8983C18.4983 23.8983 16.869 22.269 16.869 20.2621ZM27.4828 15.5086C27.4828 15.8371 27.2164 16.1034 26.8879 16.1034H24.9741C24.6457 16.1034 24.3793 15.8371 24.3793 15.5086V13.5948C24.3793 13.2664 24.6457 13 24.9741 13H26.8879C27.2164 13 27.4828 13.2664 27.4828 13.5948V15.5086ZM25.8224 18.6897H28V27.3483C28 27.6793 27.9276 28 27.6017 28H13.3776C13.0517 28 13 27.6793 13 27.3483V18.6897H15.1569C14.8466 18.6897 14.7431 19.8483 14.7431 20.3759C14.7431 23.5466 17.3345 26.0759 20.5103 26.0759C23.6966 26.0759 26.2828 23.575 26.2828 20.4043C26.2828 19.8767 26.2052 18.6897 25.8224 18.6897Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default ForwardRef;